<div
  [ngClass]="{
    'inlineEditorContainer': true,
    'inlineTextArea': true,
    'editing': editMode,
    'shortText': shortText
  }"
  >
  @if (label) {
    <span
      [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
      >
      {{label}}
    </span>
  }
  <div
    id="editableTextArea{{random}}"
    tabindex="{{tabIndex}}"
    [attr.placeholder]="placeholder"
    [attr.contenteditable]="!disabledFlag"
    aria-label='click to edit'
    (click)="changeToEdit()"
    [ngClass]="{
      'editable': true,
      'editable-textarea':true,
      'disabled':disabledFlag,
      'editing': editMode
      }"
    (blur)="onFocusOut($event)"
    (focusin)="startEdit()"
    (keydown.escape)="undo()"
    appContentEditableModel
    [(contenteditableModel)]="data"
    [(maxCharacters)]="maxChars"
    [(hasLimit)]="shortText"
    [innerHtml]="data"
    (keyup)="changeCounters($event)"
    (keydown)="changeCounters($event)"
  ></div>
  @if (hasCounter && editMode) {
    <hr>
    }
    @if (hasCounter && editMode) {
      <div class="progressWrapper weaveGrid">
        <div class="counter-instructions">
          Please limit {{label}} to {{maxChars}} characters or less.
        </div>
        <app-progress-bar
          [value]="percentage"
          [color]="progressBarColor"
        ></app-progress-bar>
        <div
          [ngClass]="counterClass"
          class="charCounter">
          &nbsp;
          @if (percentage>warningThreshold) {
            <span>{{charsLeft}}</span>
          }
        </div>
      </div>
    }
  </div>
